import { render } from "./Inspection.vue?vue&type=template&id=dd5c42c8"
import script from "./Inspection.vue?vue&type=script&lang=js"
export * from "./Inspection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__